import React, { Component, useState } from 'react';
import {
    useGetMergedGuidelines,
    useCreateMergedGuidelines,
    useCreateMergedGuidelineFromSkus,
    useAddBarcodeToGuideline,
    useAddLinkToGuideline,
    useDeleteMergeGuideline,
} from '../../hooks/useGuideline';
import PaginatedTable from '../../commonComponents/PaginatedTable';
import { Tag, Modal, Form, Input, Button, notification, Tooltip } from 'antd';
import { EyeOutlined, CopyOutlined, LinkOutlined, PlusOutlined, CopyTwoTone, DeleteOutlined } from '@ant-design/icons';
import PlusIconActionButton from '../PlusIconActionButton';
import CreateMergeGuideline from './create';
import AddBarcode from './AddBarcode';
import AddLink from '../../commonComponents/AddLink';
import InputList from '../../commonComponents/InputList';
import style from './index.module.css';
import useLogout from '../../hooks/useLogout';

export default function Guideline() {
    const [api, contextHolder] = notification.useNotification();
    const [showCreate, setShowCreate] = useState(false);
    const [selectedGuideline, setSelectedGuideline] = useState(null);
    const [showAddBarcode, setShowAddBarcode] = useState(false);
    const [showAddLink, setShowAddLink] = useState(false);
    const [loading, setLoading] = useState(false);

    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const { logout } = useLogout();
    const { data, isFetching, isFetched, refetch: refetchMergedGuidelines } = useGetMergedGuidelines(pageNum, pageSize, null);
    const CreateMergedGuidelinesMutation = useCreateMergedGuidelines();
    const CreateFromSkusMutation = useCreateMergedGuidelineFromSkus();
    const AddBarcodeToGuidelineMutation = useAddBarcodeToGuideline();
    const AddLinkToGuidelineMutation = useAddLinkToGuideline();

    const OnChangePaginator = (num, size) => {
        setPageNum(num);
        setPageSize(size);
    };

    const HandleCreationClose = () => {
        setShowCreate(false);
        setSelectedGuideline(null);
    };

    const HandleCreation = async data => {
        setLoading(true);
        const { name, description, links, ExcludeLinks, mode, skuIds } = data;
        const createPromise =
            mode === 'skus'
                ? CreateFromSkusMutation.mutateAsync([name, description, skuIds])
                : CreateMergedGuidelinesMutation.mutateAsync([name, description, links, ExcludeLinks]);
        createPromise
            .then(() => {
                api.success({
                    message: 'Successfully created',
                });
            })
            .catch(error => {
                const raw = error?.response?.data;
                let descriptionText = 'Failed to create';
                try {
                    descriptionText = typeof raw === 'string' ? JSON.parse(raw).message : raw?.message || descriptionText;
                } catch {
                    descriptionText = typeof raw === 'string' ? raw : descriptionText;
                }
                api.error({
                    message: 'Failed To Create Merged Guideline',
                    duration: 3,
                    description: descriptionText,
                });
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                setLoading(false);
                setShowCreate(false);
                refetchMergedGuidelines();
            });
    };

    const HandleAddBarcodeStart = record => {
        console.log(record);
        setSelectedGuideline(record);
        setShowAddBarcode(true);
    };

    const HandleAddBarcode = async (barcode, comment) => {
        setLoading(true);
        AddBarcodeToGuidelineMutation.mutateAsync([selectedGuideline?._id, barcode, comment])
            .then(() => {
                api.success({
                    message: `Successfully Added Barcode`,
                    description: (
                        <>
                            <div>
                                <p>{`Barcode: ${barcode}`}</p>
                                <p>{`Comment: ${comment}`}</p>
                            </div>
                        </>
                    ),
                });
            })
            .catch(error => {
                api.error({
                    message: 'Failed To Create Add Barcode',
                    duration: 3,
                    description: JSON.parse(error?.response?.data).message,
                });
                console.log(JSON.parse(error?.response?.data).message);
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                setLoading(false);
                // setShowAddBarcode(false);
                refetchMergedGuidelines();
            });

        console.log({ barcode, comment });
    };

    const HandleAddLinkToGuideline = async link => {
        setLoading(true);
        AddLinkToGuidelineMutation.mutateAsync([selectedGuideline?._id, link])
            .then(() => {
                api.success({
                    message: 'Successfully Added Link to Guideline',
                });
            })
            .catch(error => {
                api.error({
                    message: 'Failed To Create Add Barcode',
                    duration: 3,
                    description: JSON.parse(error?.response?.data).message,
                });
                console.log(JSON.parse(error?.response?.data).message);
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                setLoading(false);
                setShowAddLink(false);
                refetchMergedGuidelines();
            });
    };
    const DeleteMergeGuidelineMutation = useDeleteMergeGuideline();

    const HandleDeleteGuideline = async guideline => {
        const mergeId = guideline?._id;
        DeleteMergeGuidelineMutation.mutateAsync([mergeId])
            .then(() => {})
            .catch(error => {
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchMergedGuidelines();
            });
    };

    const Actions = ({ record }) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                    }}
                >
                    <Tooltip title="Show Merged Guideline">
                        <a href={record?.link} target="_blank">
                            <Button>
                                <EyeOutlined />
                            </Button>
                        </a>
                    </Tooltip>
                    <Tooltip title="Copy Link">
                        <Button onClick={() => navigator.clipboard.writeText(record?.link)}>
                            <LinkOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Copy Guideline Link For Mail/Excel">
                        <Button
                            onClick={() =>
                                navigator.clipboard
                                    .write([
                                        new ClipboardItem({
                                            'text/html': new Blob(
                                                [
                                                    `<table style="border:1px solid black;margin:0;padding:3px;">
                                                    <tr>
                                                        <td style="background:gray;maxWidth:100px;border:1px solid black;margin:0;padding:3px;">Shooting Guideline</td>
                                                        <td
                                                            style="align: center;justifyContent:center;border:1px solid black;margin:0;padding:3px;"
                                                        >
                                                            <a href=${record?.link}>${record?.name}</a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background:gray;maxWidth:100px;border:1px solid black;margin:0;padding:3px;">Count</td>
                                                        <td
                                                            style="display:flex;align:center;justifyContent:center;border:1px solid black;margin:0;padding:3px;"
                                                        >
                                                            ${record?.count}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background:gray;maxWidth:100px;border:1px solid black;margin:0;padding:3px;">Description</td>
                                                        <td
                                                            style="display: flex;align: center;justifyContent: center;maxWidth: 200px;textWrap: wrap;overflow: hidden;border:1px solid black;margin:0;padding:3px;"
                                                        >
                                                            ${record?.description}
                                                        </td>
                                                    </tr>
                                                </table>`,
                                                ],
                                                {
                                                    type: 'text/html',
                                                }
                                            ),
                                        }),
                                    ])
                                    .then(() => {
                                        console.log('Write successful : clipboard');
                                    })
                                    .catch(error => {
                                        console.log(error);
                                    })
                            }
                        >
                            <CopyOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Add Barcode to Merged Guideline">
                        <Button onClick={() => HandleAddBarcodeStart(record)}>
                            <PlusOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Add Link To Guideline">
                        <Button
                            onClick={() => {
                                setShowAddLink(true);
                                setSelectedGuideline(record);
                            }}
                        >
                            <PlusOutlined />
                            <LinkOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Clone">
                        <Button
                            onClick={() => {
                                setSelectedGuideline(record);
                                setShowCreate(true);
                            }}
                        >
                            <CopyTwoTone />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button
                            onClick={() => {
                                HandleDeleteGuideline(record);
                            }}
                        >
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </div>
            </>
        );
    };

    const columns = [
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: 'Description',
            key: 'description',
            render: (_, record) => {
                return {
                    children: (
                        <p
                            style={{
                                maxHeight: '150px',
                                overflow: 'auto',
                            }}
                        >
                            {record?.description}
                        </p>
                    ),
                    props: {
                        style: { maxWidth: '200px' },
                    },
                };
            },
        },
        {
            title: 'Created By',
            key: 'createdBy',
            render: (_, record) => {
                return <p>{record?.generatedBy?.name}</p>;
            },
        },
        {
            title: 'Created At',
            key: 'createdAt',
            render: (_, record) => {
                return (
                    record?.createdAt && (
                        <p>{`${new Date(record?.createdAt).toLocaleString('en-GB', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                        })}`}</p>
                    )
                );
            },
            width: '8%',
        },
        {
            title: 'Used SGL Links',
            key: 'links',
            render: (_, record) => {
                return (
                    <div>
                        {record?.links?.map((link, index) => (
                            <a href={link} target="_blank">
                                <Tag className={style.Link}>{index + 1}</Tag>
                            </a>
                        ))}
                    </div>
                );
            },
        },
        {
            title: 'Sku Count',
            key: 'count',
            dataIndex: 'count',
        },
        {
            title: 'Action',
            key: 'actions',
            render: (_, record) => <Actions record={record} />,
        },
    ];

    return (
        <>
            {contextHolder}
            <PaginatedTable
                dataSource={data?.data}
                columns={columns}
                isFetching={isFetching}
                total={data?.total}
                OnChangePaginator={OnChangePaginator}
                defaultPageSize={20}
                pageNum={pageNum}
                pageSize={pageSize}
                key="MergedGuidelineList"
            />
            <PlusIconActionButton title="Create New Merged Guidelines" onClick={() => setShowCreate(true)} />
            {showCreate && (
                <CreateMergeGuideline
                    HandleOnOK={HandleCreation}
                    loading={loading}
                    onCancel={HandleCreationClose}
                    showCreate={showCreate}
                    key="CreateMergedLink"
                    name={selectedGuideline?.name}
                    description={selectedGuideline?.description}
                    links={selectedGuideline?.links}
                />
            )}
            {!!showAddBarcode && !!selectedGuideline && (
                <AddBarcode
                    onCancel={() => {
                        setShowAddBarcode(false);
                        setSelectedGuideline(null);
                    }}
                    open={showAddBarcode}
                    title={`${selectedGuideline?.name}`}
                    loading={loading}
                    updateGuideline={HandleAddBarcode}
                />
            )}
            {!!showAddLink && !!selectedGuideline && (
                <AddLink
                    onCancel={() => {
                        setShowAddLink(false);
                        setSelectedGuideline(null);
                    }}
                    open={showAddLink}
                    title={`${selectedGuideline?.name}`}
                    loading={loading}
                    updateGuideline={HandleAddLinkToGuideline}
                />
            )}
        </>
    );
}
